import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import BannerGlobal from '../../Components/Banner/BannerGlobal'
import ServiceDetailsComponent from '../../Components/ServiceComponent/ServiceDetailsComponent'
import ContactComponent from '../../Components/ContactComponent/ContactComponent'
import useDocumentTitle from '../../PageTitle'

const ServiceDetails = () => {
  useDocumentTitle("Roofing | Service Details")
  return (
    <div>
        <Header/>
        <BannerGlobal/>
        <ServiceDetailsComponent/>
        <ContactComponent/>
        <Footer/>
    </div>
  )
}

export default ServiceDetails